export default id => {
  const group = Number(String(id).substring(0, 1));

  switch (group) {
    case 2:
      return getIcon('thunderstorm');
    case 3:
      return getIcon('drizzle');
    case 5:
      return getIcon('rain');
    case 6:
      return getIcon('snow');
    case 7:
      return getIcon('fog');
    case 8:
      switch (id) {
        case 800:
          return getIcon('clear');
        case 801:
          return getIcon('few-clouds');
        case 802:
          return getIcon('cloudy');
        case 803:
          return getIcon('clouds');
        case 804:
          return getIcon('clouds');
      }
  }
}

function getIcon(icon) {
  return require('./assets/icons/weather/' + icon + '.svg')
}